mutation moveLeadsToCompany($input: MoveLeadToCompanyInput!) {
    moveLeadsToCompany(input: $input)
}
